
import { ReducerRegistry } from '../base/redux';
import { ACTION_TOGGLE_ETHERPAD } from '../toolbox/actionTypes';

import { OPEN_ETHER_PAD, SET_DOCUMENT_EDITING_STATUS, SET_DOCUMENT_URL,
    TOGGLE_DOCUMENT_EDIT, WHICH_PARTICPANT_ETHERPAD } from './actionTypes';

const DEFAULT_STATE = {

    /**
     * URL for the shared document.
     */
    documentUrl: undefined,

    /**
     * Whether or not Etherpad is currently open.
     *
     * @public
     * @type {boolean}
     */
    editing: false,

    /**
     * ONclick function.
     */
    onEdit: false,


    partId: null,
    openEtherPad: false,
    actionToggleEtherPad: false
};

/**
 * Reduces the Redux actions of the feature features/etherpad.
 */
ReducerRegistry.register(
    'features/etherpad',
    (state = DEFAULT_STATE, action) => {
        switch (action.type) {
        case SET_DOCUMENT_EDITING_STATUS:
            return {
                ...state,
                editing: action.editing
            };

        case SET_DOCUMENT_URL:
            return {
                ...state,
                documentUrl: action.documentUrl
            };

        case TOGGLE_DOCUMENT_EDIT: {

            return {
                ...state,
                onEdit: action.onEdit
            };
        }

        case WHICH_PARTICPANT_ETHERPAD: {
            return {
                ...state,
                partId: action.partId
            };
        }

        case OPEN_ETHER_PAD : {
            return {
                ...state,
                openEtherPad: action.open
            };
        }

        case ACTION_TOGGLE_ETHERPAD : {
            return {
                ...state,
                actionToggleEtherPad: action.bool
            };
        }

        default:
            return state;
        }
    });
